import './groups.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import { createGroup, destroyGroup, updateGroup } from '../../actions/group';
import LoupeGreenLight from '../../res/img/loupe_green_light.svg';
import Profile from '../../res/img/member.svg';
import TrashbinWhite from '../../res/img/trashbin_white.svg';
import Navigation from '../Navigation/global';

interface IProps {
  groups: Group[];
  members: Member[];
  destroyGroup: (group: Group) => void;
  updateGroup: (group: Group) => void;
  createGroup: (group: Group) => void;
}

interface IState {
  keyword: string;
  currentGroup: Group | null;
  newGroup: Group;
}

class GroupsComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      keyword: '',
      currentGroup: null,
      newGroup: new Group()
    };

    this.onChangeKeyword = this.onChangeKeyword.bind(this);
    this.onChangeNewGroup = this.onChangeNewGroup.bind(this);
    this.onChangeGroupTitle = this.onChangeGroupTitle.bind(this);
    this.onBlurGroupTitle = this.onBlurGroupTitle.bind(this);
    this.onChangeMemoFormat = this.onChangeMemoFormat.bind(this);
    this.onBlurGroupMemoFormat = this.onBlurGroupMemoFormat.bind(this);
    this.createGroup = this.createGroup.bind(this);
    this.onChangeIsPublic = this.onChangeIsPublic.bind(this);
  }

  render() {
    return (
      <div id="AdminGroups">
        <Navigation group="システム管理" />

        <div id="Tabs">
          <Link to={'/admin/members'}>
            <div className="Tab">メンバー管理</div>
          </Link>
          <div className="Tab TabSelected">グループ管理</div>
        </div>

        <div id="Content">
          <div id="ContentLeft">
            <div id="AllGroups">
              <label>すべてのグループ</label>
              <div className="Search">
                <img src={LoupeGreenLight} />
                <input
                  className="InputText"
                  value={this.state.keyword}
                  onChange={this.onChangeKeyword}
                />
              </div>
              <div className="Groups">
                {this.props.groups
                  .filter(group => group.title.includes(this.state.keyword))
                  .map(group => (
                    <div
                      key={group.id}
                      className={
                        this.state.currentGroup !== null &&
                        group.id === this.state.currentGroup.id
                          ? 'Group GroupSelected'
                          : 'Group'
                      }
                      onMouseUp={this.selectGroup.bind(this, group)}
                    >
                      <span>{group.title}</span>
                    </div>
                  ))}
              </div>
            </div>

            <div id="AddGroup">
              <label>グループの追加</label>
              <div className="Search">
                <img src={LoupeGreenLight} />
                <input
                  className="InputText"
                  placeholder="グループ名を入力"
                  value={this.state.newGroup.title}
                  onKeyUp={this.createGroup}
                  onChange={this.onChangeNewGroup}
                />
              </div>
            </div>
          </div>
          {this.state.currentGroup !== null ? (
            <div id="ContentRight">
              <div id="GroupTitle">
                <input
                  className="InputText"
                  value={this.state.currentGroup.title}
                  onChange={this.onChangeGroupTitle}
                  onBlur={this.onBlurGroupTitle}
                />
              </div>
              <div id="GroupIsPublic">
                <label>公開設定</label>
                <select
                  onChange={this.onChangeIsPublic}
                  defaultValue={
                    this.state.currentGroup.isPublic ? 'true' : 'false'
                  }
                >
                  <option value={'true'}>公開</option>
                  <option value={'false'}>非公開</option>
                </select>
              </div>

              <div id="GroupMemoFormat">
                <label>メモのフォーマット</label>
                <textarea
                  value={this.state.currentGroup.memoFormat}
                  onChange={this.onChangeMemoFormat}
                  onBlur={this.onBlurGroupMemoFormat}
                />
              </div>

              <div id="GroupMembers">
                <label>所属メンバー</label>
                {this.props.members
                  .filter(member =>
                    (this.state.currentGroup as Group).members.includes(
                      member.id
                    )
                  )
                  .sort((a, b) => (a.archived && !b.archived ? 1 : -1))
                  .map(member => (
                    <div className="MemberContainer" key={member.id}>
                      <div className="Member">
                        <img
                          src={
                            member.profile !== null ? member.profile : Profile
                          }
                        />
                        <span>{member.nameLast + member.nameFirst}</span>
                      </div>
                      <div
                        className="Delete"
                        onMouseUp={this.deleteMember.bind(this, member.id)}
                      >
                        <img src={TrashbinWhite} />
                      </div>
                    </div>
                  ))}
              </div>

              {!this.state.currentGroup.archived ? (
                <button
                  id="ArchiveMember"
                  onMouseUp={this.archiveGroup.bind(
                    this,
                    this.state.currentGroup
                  )}
                >
                  アーカイブ
                </button>
              ) : (
                <button
                  id="ArchiveMember"
                  onMouseUp={this.unarchiveGroup.bind(
                    this,
                    this.state.currentGroup
                  )}
                >
                  アクティブに戻す
                </button>
              )}

              <button
                id="DeleteGroup"
                onMouseUp={this.destroyGroup.bind(
                  this,
                  this.state.currentGroup
                )}
              >
                削除
              </button>
            </div>
          ) : (
            <div id="ContentRight" />
          )}
        </div>
      </div>
    );
  }

  selectGroup(group: Group, e: any) {
    this.setState({
      currentGroup: group
    });
  }

  onChangeKeyword(e: any) {
    this.setState({
      keyword: e.target.value
    });
  }

  onChangeNewGroup(e: any) {
    const group = Object.assign({}, this.state.newGroup);
    group.title = e.target.value;
    this.setState({
      newGroup: group
    });
  }

  onChangeGroupTitle(e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    group.title = e.target.value;
    this.setState({
      currentGroup: group
    });
  }

  onChangeMemoFormat(e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    group.memoFormat = e.target.value;
    this.setState({
      currentGroup: group
    });
  }

  onChangeIsPublic(e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    group.isPublic = e.target.value === 'true' ? true : false;
    this.setState({
      currentGroup: group
    });
    this.props.updateGroup(group);
  }

  onBlurGroupTitle(e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    this.props.updateGroup(group);
  }

  onBlurGroupMemoFormat(e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    this.props.updateGroup(group);
  }

  createGroup(e: any) {
    if (e.keyCode === 13) {
      const group = Object.assign({}, this.state.newGroup);
      this.props.createGroup(group);
      this.setState({
        newGroup: new Group()
      });
    }
  }

  archiveGroup(group: Group, e: any) {
    if (confirm('このグループをアーカイブします')) {
      group.archived = true;
      this.props.updateGroup(group);
    }
  }

  unarchiveGroup(group: Group, e: any) {
    if (confirm('このグループをアクティブに戻します')) {
      group.archived = false;
      this.props.updateGroup(group);
    }
  }

  destroyGroup(group: Group, e: any) {
    if (confirm('このグループを削除します')) {
      this.props.destroyGroup(group);
    }
  }

  deleteMember(memberId: number, e: any) {
    const group = Object.assign({}, this.state.currentGroup);
    group.members = group.members.filter(member => member !== memberId);
    group.admins = group.admins.filter(member => member !== memberId);

    this.props.updateGroup(group);
    this.setState({
      currentGroup: group
    });
  }
}

const mapStateToProps = (state: any) => ({
  groups: state.Group,
  members: state.Member
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    destroyGroup(group: Group) {
      dispatch(destroyGroup(group));
    },
    updateGroup(group: Group) {
      dispatch(updateGroup(group));
    },
    createGroup(group: Group) {
      dispatch(createGroup(group));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupsComponent);



// WEBPACK FOOTER //
// ./src/components/Admin/groups.tsx